export default {
    page: function() {
        this.loadAgencies()
    }
}
